import React from "react"
import { Link } from "gatsby"


const SubPageMenu = (props) => {

  return (

    <ul className={`flex flex-wrap mx-auto justify-center ${props.contMargins}`}>
      {props.pages.map(d => (
        d.url === "none" ? (
          <li key={d.name}>
            <button onClick={d.stateHandler} className={`${props.btnPadding} mx-2 mt-3 leading-6 cursor-pointer ${props.btnTextSize} rounded-full transition-300 focus:outline-none ${d.active ? 'bg-highlight text-noir' : 'bg-slate-700 text-slate-200 hover:bg-slate-200 focus:bg-slate-600 hover:text-noir'}`}>
              {d.name}
            </button>
          </li>
        )
        : <li key={d.name}>
            <Link className={`block ${props.btnPadding} mx-2 mt-3 leading-6 ${props.btnTextSize} rounded-full cursor-pointer transition-300 focus:outline-none ${d.active ? 'bg-highlight' : 'bg-slate-700 hover:bg-slate-200 focus:bg-slate-600 hover:text-noir'}`} to={d.url}>{d.name}</Link>
          </li>
      ))}
    </ul>

  )
}

SubPageMenu.defaultProps = {
  contMargins: "mt-4 md:mt-6 2xl:mt-8 md:mb-4 xl:mb-6",
  btnPadding: "px-4 py-2",
  btnTextSize: "text-sm",
};

export default SubPageMenu